export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  TOGGLE_SIDEBAR_DROPDOWN: "TOGGLE_SIDEBAR_DROPDOWN",
  TOGGLE_PAYROLL_DROPDOWN: "TOGGLE_PAYROLL_DROPDOWN",
  TOGGLE_SUB_MENU_DROPDOWN:"TOGGLE_SUB_MENU_DROPDOWN"
};
